import React from "react";
import { Loader } from "semantic-ui-react";

import { useDictionary } from "hooks";

import styles from "./styles.css";

const ReportingLoader = () => {
    const dictionary = useDictionary("reporting.loader");
    return (
        <div className={styles.overlay}>
            <div className={styles.loadingBlock}>
                <div className={styles.loader}>
                    <Loader active size="medium" />
                </div>
                <div className={styles.loadingText}>
                    <h3>{dictionary.label ?? "Creating report."}</h3>
                    <span className={styles.description}>
                        {dictionary.description ??
                            "Reports with large amounts of data may take some time to be created. Navigating away from this page will cancel report creation."}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ReportingLoader;
